import { render, staticRenderFns } from "./payStatus.vue?vue&type=template&id=960c25fa&scoped=true"
import script from "./payStatus.vue?vue&type=script&lang=js"
export * from "./payStatus.vue?vue&type=script&lang=js"
import style0 from "./payStatus.vue?vue&type=style&index=0&id=960c25fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960c25fa",
  null
  
)

export default component.exports